import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";
export const fetchContractList = createAsyncThunk(
    'contract/fetchContractList',
    async ({ value, sortArray }: {
        value: boolean,
        sortArray: string[] | [],
    }, { rejectWithValue }) => {
        try {
            const response = await getRequest({
                "Active": value,
                "Limit": 10000000000000,
                "Offset": 0,
                "SortableColumns": sortArray
            }, 'dms-hr', 'getList', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { list: data.Contracts, contractCount: data.ContractCount, fetchTime: parseToTimestamp(new Date()) };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);


export const fetchExelDownload = createAsyncThunk(
    'contract/fetchExelDownload',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getRequest({}, 'dms-hr', 'downloadContractsFile', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { FileData: data.File.DataBase64, FileName: data.File.Name };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);